import {
  CatSegmentedControl,
  CatSegmentedControlItem
} from 'components/blocks-components';
import styles from './product-diagram-drawer-header.module.scss';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { BlocksSegmentItemChange } from '@blocks-web-components/events';
import { ProductDiagramDrawerBackHeaderMobile } from '../product-diagram-back-header';

const ProductDiagramDrawerHeader = ({
  closeDrawer,
  drawerHeading,
  drawerSubHeading = '',
  isActiveListTab,
  setIsChecked,
  disablePartDiagramTab,
  cartServerBtn,
  diagramViewGaAttributes,
  listViewButtonGaAttributes
}: {
  closeDrawer: () => void;
  drawerHeading: string;
  drawerSubHeading?: string;
  isActiveListTab: boolean;
  setIsChecked: (e: BlocksSegmentItemChange) => void;
  disablePartDiagramTab: boolean;
  cartServerBtn?: React.ReactNode;
  diagramViewGaAttributes?: Record<string, string>;
  listViewButtonGaAttributes?: Record<string, string>;
}) => {
  const t = useTranslations();
  return (
    <ProductDiagramDrawerBackHeaderMobile
      className={styles['product-diagram-drawer-header']}
      handleClose={closeDrawer}
      drawerHeading={drawerHeading}
      drawerSubHeading={drawerSubHeading}
      cartServerBtn={cartServerBtn}
    >
      <CatSegmentedControl
        activeIndex={!isActiveListTab ? 0 : 1}
        onBlSegmentItemChange={setIsChecked}
        className={cx(styles['segmented-controls'], 'mt-3')}
      >
        <CatSegmentedControlItem
          disabled={disablePartDiagramTab}
          className={cx(styles['segmented-control-item'])}
          {...diagramViewGaAttributes}
        >
          {t('PDP_SCHEMATIC_DIAGRAM')}
        </CatSegmentedControlItem>
        <CatSegmentedControlItem
          className={styles['segmented-control-item']}
          {...listViewButtonGaAttributes}
        >
          {t('SEGMENTED_LISTVIEW')}
        </CatSegmentedControlItem>
      </CatSegmentedControl>
    </ProductDiagramDrawerBackHeaderMobile>
  );
};

export default ProductDiagramDrawerHeader;
